export default {
  components: {},
};
